var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "width": "1400px",
      "title": !_vm.dataForm.id ? 'Add Quotation (V)' : 'Edit Quotation (V)',
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "top": "1vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Transaction Type",
      "prop": "transactionType"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.transactionType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "transactionType", $$v);
      },
      expression: "dataForm.transactionType"
    }
  }, _vm._l(_vm.transactionTypeList, function (item) {
    return _c('el-option', {
      key: "transactionType-".concat(item.title),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Linked Transaction No.",
      "prop": "applymentNo"
    }
  }, [_c('business-info-select-remote-search', {
    attrs: {
      "placeholder": "Transaction No."
    },
    model: {
      value: _vm.dataForm.applymentNo,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "applymentNo", $$v);
      },
      expression: "dataForm.applymentNo"
    }
  })], 1)], 1), _vm.dataForm.transactionType == 2 ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Order No.",
      "prop": "refundOrderIds"
    }
  }, [_vm.dataForm.applymentNo ? [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": "",
      "placeholder": "Order No.",
      "loading": _vm.refundOrderLoading
    },
    model: {
      value: _vm.dataForm.refundOrderIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "refundOrderIds", $$v);
      },
      expression: "dataForm.refundOrderIds"
    }
  }, _vm._l(_vm.refundOrderOptions, function (item) {
    return _c('el-option', {
      key: "refundOrder-".concat(item.id),
      attrs: {
        "label": item.orderNo,
        "value": item.id
      }
    });
  }), 1)] : _c('div', {
    staticClass: "pt0 pb0 notSelectTipBg"
  }, [_vm._v("Select Linked Transaction No. first")])], 2)], 1) : _vm._e(), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Client Code",
      "prop": "clientCode"
    }
  }, [_c('client-code-select-remote-search', {
    attrs: {
      "showItems": ['companyName', 'billingAddresses'],
      "placeholder": "Client Code"
    },
    on: {
      "change-item": _vm.clientCodeChange
    },
    model: {
      value: _vm.dataForm.clientCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "clientCode", $$v);
      },
      expression: "dataForm.clientCode"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Billing Party",
      "prop": "billingParty"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Billing party"
    },
    model: {
      value: _vm.dataForm.billingParty,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "billingParty", $$v);
      },
      expression: "dataForm.billingParty"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Address"
    },
    model: {
      value: _vm.dataForm.address,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "address", $$v);
      },
      expression: "dataForm.address"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "country"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "placeholder": "Country",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Postal Code",
      "prop": "postalCode"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Postal Code"
    },
    model: {
      value: _vm.dataForm.postalCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "postalCode", $$v);
      },
      expression: "dataForm.postalCode"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Supplier",
      "prop": "supplierId"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Supplier"
    },
    on: {
      "change": _vm.supplierChange
    },
    model: {
      value: _vm.dataForm.supplierId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierId", $$v);
      },
      expression: "dataForm.supplierId"
    }
  }, _vm._l(_vm.supplierList, function (item) {
    return _c('el-option', {
      key: "supplier-".concat(item.id),
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Invoice Template",
      "prop": "invoiceTemplateId"
    }
  }, [_vm.dataForm.supplierId ? [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.invoiceTemplateChange
    },
    model: {
      value: _vm.dataForm.invoiceTemplateId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "invoiceTemplateId", $$v);
      },
      expression: "dataForm.invoiceTemplateId"
    }
  }, _vm._l(_vm.invoiceTemplateOptions, function (item) {
    return _c('el-option', {
      key: "invoiceTemplate-".concat(item.id),
      attrs: {
        "label": item.templateName,
        "value": item.id
      }
    });
  }), 1)] : _c('div', {
    staticClass: "pt0 pb0 notSelectTipBg"
  }, [_vm._v("Select supplier first")])], 2)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Accounts",
      "prop": "bankAccountIds"
    }
  }, [_vm.dataForm.invoiceTemplateId ? [_c('select-bank-account', {
    attrs: {
      "supplierBankAccountList": _vm.invoiceTemplateBankAccountList
    },
    model: {
      value: _vm.dataForm.bankAccountIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "bankAccountIds", $$v);
      },
      expression: "dataForm.bankAccountIds"
    }
  })] : _c('div', {
    staticClass: "notSelectTipBg"
  }, [_vm._v("Select invoice template first")])], 2)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Quotation (V) Items",
      "prop": "itemList"
    }
  }, [_c('div', {
    staticClass: "addBtnWrap"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.addHandle
    }
  }, [_vm._v("Add Item")])], 1), _c('div', {
    staticClass: "itemListWrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 3
    }
  }, [_vm._v("Category")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Description")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 2
    }
  }, [_vm._v("Currency")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 3
    }
  }, [_vm._v("Orig. Amount")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 3
    }
  }, [_vm._v("Ex Rate")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 3
    }
  }, [_vm._v("Amount")])], 1), _vm._l(_vm.dataForm.itemList, function (ele, index) {
    return _c('div', {
      key: "category-".concat(index),
      staticClass: "wdb100"
    }, [_c('el-row', {
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('el-button', {
      staticClass: "pd0 fwb el-icon-top",
      attrs: {
        "type": "text",
        "size": "mini",
        "disabled": index == 0
      },
      on: {
        "click": function click($event) {
          return _vm.moveItem(index, -1);
        }
      }
    }), _c('el-button', {
      staticClass: "pd0 fwb el-icon-bottom",
      attrs: {
        "type": "text",
        "size": "mini",
        "disabled": index == _vm.dataForm.itemList.length - 1
      },
      on: {
        "click": function click($event) {
          return _vm.moveItem(index, 1);
        }
      }
    })], 1), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "itemList.".concat(index, ".category"),
        "rules": {
          required: true,
          message: 'please select',
          trigger: 'submit'
        }
      }
    }, [_c('el-select', {
      staticClass: "wdb100",
      attrs: {
        "clearable": "",
        "filterable": "",
        "placeholder": "Category"
      },
      model: {
        value: ele.category,
        callback: function callback($$v) {
          _vm.$set(ele, "category", $$v);
        },
        expression: "ele.category"
      }
    }, _vm._l(_vm.invoiceItemCategoryList, function (item) {
      return _c('el-option', {
        key: "category-".concat(item.value, "-").concat(index),
        attrs: {
          "label": item.title,
          "value": item.value
        }
      });
    }), 1)], 1)], 1), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "itemList.".concat(index, ".description"),
        "rules": {
          required: true,
          message: 'please select',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "clearable": "",
        "placeholder": "Description"
      },
      model: {
        value: ele.description,
        callback: function callback($$v) {
          _vm.$set(ele, "description", $$v);
        },
        expression: "ele.description"
      }
    })], 1)], 1), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "itemList.".concat(index, ".originalCurrency"),
        "rules": {
          required: true,
          message: 'please select',
          trigger: 'submit'
        }
      }
    }, [_c('el-select', {
      staticClass: "wdb100",
      attrs: {
        "filterable": "",
        "clearable": "",
        "placeholder": "Currency"
      },
      model: {
        value: ele.originalCurrency,
        callback: function callback($$v) {
          _vm.$set(ele, "originalCurrency", $$v);
        },
        expression: "ele.originalCurrency"
      }
    }, _vm._l(_vm.currencyList, function (item) {
      return _c('el-option', {
        key: item.currency,
        attrs: {
          "label": item.currency,
          "value": item.currency
        }
      });
    }), 1)], 1)], 1), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "itemList.".concat(index, ".originalAmount"),
        "rules": {
          required: true,
          message: 'please enter',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      directives: [{
        name: "minusPoint2",
        rawName: "v-minusPoint2"
      }],
      attrs: {
        "clearable": "",
        "placeholder": "Orig. Amount"
      },
      on: {
        "input": function input($event) {
          return _vm.calculateTotal(ele);
        }
      },
      model: {
        value: ele.originalAmount,
        callback: function callback($$v) {
          _vm.$set(ele, "originalAmount", $$v);
        },
        expression: "ele.originalAmount"
      }
    }, [_c('template', {
      slot: "prefix"
    }, [_vm._v(_vm._s(_vm.currencySymbolFormat(ele.originalCurrency)))])], 2)], 1)], 1), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "itemList.".concat(index, ".exchangeRate"),
        "rules": {
          required: true,
          message: 'please enter',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      directives: [{
        name: "positivePoint",
        rawName: "v-positivePoint",
        value: 6,
        expression: "6"
      }],
      attrs: {
        "clearable": "",
        "placeholder": "Ex Rate"
      },
      on: {
        "input": function input($event) {
          return _vm.calculateTotal(ele);
        }
      },
      model: {
        value: ele.exchangeRate,
        callback: function callback($$v) {
          _vm.$set(ele, "exchangeRate", $$v);
        },
        expression: "ele.exchangeRate"
      }
    })], 1)], 1), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "itemList.".concat(index, ".billingAmount"),
        "rules": {
          required: true,
          message: 'please enter',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      directives: [{
        name: "minusPoint2",
        rawName: "v-minusPoint2"
      }],
      attrs: {
        "clearable": "",
        "placeholder": "Amount"
      },
      model: {
        value: ele.billingAmount,
        callback: function callback($$v) {
          _vm.$set(ele, "billingAmount", $$v);
        },
        expression: "ele.billingAmount"
      }
    }, [_c('template', {
      slot: "prefix"
    }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.billingCurrency)))])], 2)], 1)], 1), _c('el-col', {
      staticClass: "tac",
      attrs: {
        "span": 1
      }
    }, [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small",
        "icon": "el-icon-delete",
        "plain": ""
      },
      on: {
        "click": function click($event) {
          return _vm.deleteHandle(index);
        }
      }
    })], 1)], 1)], 1);
  })], 2)])], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.dataForm.transactionType == 2 ? 'Apply Reason (For External Disclosure)' : 'Description (For External Disclosure)',
      "prop": "applyReason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "autosize": {
        minRows: 4
      },
      "resize": "none",
      "placeholder": "English wording is mandatory, Chinese translation is optional"
    },
    model: {
      value: _vm.dataForm.applyReason,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "applyReason", $$v);
      },
      expression: "dataForm.applyReason"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Attachments",
      "prop": "attachmentUrls"
    }
  }, [_c('el-multiple-file-uploader', {
    model: {
      value: _vm.dataForm.attachmentUrls,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "attachmentUrls", $$v);
      },
      expression: "dataForm.attachmentUrls"
    }
  })], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }